import { React, useEffect, useState } from "react";
import axios from "axios";
import { CompanyTable, CompanyCreate } from "..";
import SearchIcon from "@mui/icons-material/Search";

function CompanySearch() {
  const [companyName, setCompanyName] = useState("");

  const [csType, setCSType] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [updateTable, setUpdateTable] = useState(false);

  useEffect(() => {
    showCompanySearchResults();
  }, [companyName, csType, updateTable]);

  const showCompanySearchResults = () => {
    const body = new FormData();
    body.append("companyName", companyName);
    axios.post("/company/searchCompanies", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setCompanies(data.companies);
      } else {
      }
    });
  };

  const resetHooks = () => {
    setCompanyName("");
    setCSType([]);
  };

  return (
    <div className="CompanySearch bg-brand-tertiary h-full">
      <div className="CompanySearch-container flex flex-col p-8 h-full">
        <div className="CompanySearch-topContainer flex flex-wrap">
          <div className="CompanySearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>

          <button
            type="button"
            className="CompanySearch-resetButton search-button px-4 h-11 mb-4 text-center py-2"
            onClick={resetHooks}>
            Reset Search
          </button>
        </div>
        <div className="CompanySearch-bottomContainer flex w-full h-full">
          <CompanyTable
            companies={companies}
            updateTable={updateTable}
            setUpdateTable={setUpdateTable}
          />
        </div>
      </div>
    </div>
  );
}

export default CompanySearch;
